/**
 * Utilitários para processamento e classificação de logs
 */

/**
 * Tipos de log padronizados
 */
export type LogLevel = 'error' | 'warn' | 'info' | 'debug' | 'unknown';

/**
 * Normaliza um nível de log para um dos tipos padronizados
 * 
 * @param level O nível de log a ser normalizado
 * @param message Mensagem de log opcional para análise adicional
 * @returns O nível de log normalizado
 */
export const normalizeLogLevel = (level: string | undefined, message?: string): LogLevel => {
  if (!level && !message) return 'unknown';
  
  // Normalizar o nível de log baseado no valor do campo level
  if (level) {
    const lowerLevel = level.toLowerCase();
    
    if (lowerLevel.includes('error') || lowerLevel === 'err' || lowerLevel === '50') {
      return 'error';
    }
    
    if (lowerLevel.includes('warn') || lowerLevel === '40') {
      return 'warn';
    }
    
    if (lowerLevel.includes('info') || lowerLevel === '30') {
      return 'info';
    }
    
    if (lowerLevel.includes('debug') || lowerLevel === 'dbg' || lowerLevel === '20') {
      return 'debug';
    }
  }
  
  // Se não conseguimos determinar pelo nível, tentar pela mensagem
  if (message) {
    const lowerMessage = message.toLowerCase();
    
    if (lowerMessage.includes('error')) {
      return 'error';
    }
    
    if (lowerMessage.includes('warn')) {
      return 'warn';
    }
    
    if (lowerMessage.includes('info')) {
      return 'info';
    }
    
    if (lowerMessage.includes('debug')) {
      return 'debug';
    }
  }
  
  // Se não conseguimos determinar, assumir info como padrão
  return 'info';
};
